import React from 'react';
import {
  PageEntityView,
  PageJobCollectionView,
  PageLinkView,
  PageLocationView,
} from '@eaco/forms-ui-web';
import type { ReadOnlyBlock } from '@eaco/forms-ui-web/readonly';

/**
 * The workspace blocks PageReadOnly leaves to its host, drawn the way the
 * portal always has: entity and job-collection blocks as markers (live data
 * never leaves Eaco), page links by title, locations as the static map. None
 * of these mount an editor.
 */
export function renderPortalBlock(block: ReadOnlyBlock): React.ReactNode | undefined {
  const typeId = block.typeId ?? '';
  const element = block as React.ComponentProps<typeof PageEntityView>['element'];
  if (typeId === 'page-entity' || typeId.startsWith('page-entity-')) return <PageEntityView element={element} />;
  if (typeId === 'page-job-board' || typeId === 'page-job-list') return <PageJobCollectionView element={element} />;
  if (typeId === 'page-link') return <PageLinkView element={element} />;
  // The static map needs coordinates; an address-only block falls back to
  // PageReadOnly's own address link instead of an empty map slot.
  if (typeId === 'page-location') {
    const { lat, lng } = (block.data ?? {}) as { lat?: unknown; lng?: unknown };
    return typeof lat === 'number' && typeof lng === 'number' ? <PageLocationView element={element} /> : undefined;
  }
  return undefined;
}
